import { useEffect, useState } from "react";

/** Soft UI timeout: stop showing endless "Loading…" if the quote hangs. */
export const QUOTE_LOADING_UI_TIMEOUT_MS = 15_000;

/**
 * True after `quoteLoading` has stayed true for QUOTE_LOADING_UI_TIMEOUT_MS.
 * Resets when loading clears. Does not cancel the in-flight fetch.
 */
export function useQuoteLoadingTimedOut(quoteLoading: boolean): boolean {
  const [timedOut, setTimedOut] = useState(false);

  useEffect(() => {
    if (!quoteLoading) {
      setTimedOut(false);
      return;
    }
    const id = window.setTimeout(() => {
      setTimedOut(true);
    }, QUOTE_LOADING_UI_TIMEOUT_MS);
    return () => window.clearTimeout(id);
  }, [quoteLoading]);

  return timedOut;
}
